import React from "react";
import { Container } from 'react-bootstrap';

const linkStyle = {
  color: "#d63384",
  textDecoration: "underline",
  fontWeight: 500,
};

const GDPRPolicy = () => {
  return (
    <Container className="my-5 text-start gdpr-policy">
      <div
        style={{
          background: "#e0e0e0",
          borderRadius: "20px",
          padding: "40px",
          boxShadow: "10px 10px 30px #bebebe, -10px -10px 30px #ffffff",
        }}
      >
        <h2 className="mb-4 fw-bold text-primary-dark">Politica de Confidențialitate (GDPR)</h2>

        <section className="mb-4">
          <h4 className="fw-semibold">INTRO</h4>
          <p>
            Partidul România Dreaptă și Prosperă (PRDP) este un partid politic înființat conform legii. 
            Ne angajăm să protejăm confidențialitatea datelor cu caracter personal în conformitate
            cu Regulamentul (UE) 679/2016 și Legea 190/2018. Datele colectate sunt
            prelucrate în scopul realizării obiectivelor politice.
          </p>
        </section>

        <section className="mb-4">
          <h4 className="fw-semibold">Tipurile de date colectate</h4>
          <p>
            Colectăm date precum: nume, prenume, adresă, email și alte date oferite
            prin formularele noastre.
          </p>
        </section>

        <section className="mb-4">
          <h4 className="fw-semibold">Date Colectate și Scop</h4>
          <p>Colectăm următoarele date pentru:</p>
          <ul
            className="ps-4"
            style={{
              listStyleType: "disc",
              listStylePosition: "outside",
              marginLeft: 0,
            }}
          >
            <li style={{ display: "list-item", marginBottom: "0.5rem" }}>
              <strong>Prenume/Nume:</strong> Identificarea dvs. în registrele partidului (Baza legală: executarea unui contract).
            </li>
            <li style={{ display: "list-item", marginBottom: "0.5rem" }}>
              <strong>CNP:</strong> Verificarea identității și eligibilității ca membru (Baza legală: consimțământ explicit, conform Legii 363/2018).
            </li>
            <li style={{ display: "list-item", marginBottom: "0.5rem" }}>
              <strong>Județ/Oraș/Țară:</strong> Analiză geografică și organizarea activităților.
            </li>
            <li style={{ display: "list-item", marginBottom: "0.5rem" }}>
              <strong>Email/Telefon:</strong> Comunicare privind evenimente și inițiative (Baza legală: consimțământ).
            </li>
            <li style={{ display: "list-item", marginBottom: "0.5rem" }}>
              <strong>Membru/Voluntar:</strong> Stabilirea drepturilor și responsabilităților în partid.
            </li>
          </ul>
        </section>

        <section className="mb-4">
          <h4 className="fw-semibold">Durata de stocare</h4>
          <p>
            Datele sunt păstrate atât timp cât este necesar pentru scopurile pentru care au fost colectate,
            respectând cerințele legale aplicabile și prevederile GDPR. În cazul în care consimțământul este
            retras, datele vor fi șterse sau anonimizate, cu excepția situațiilor în care păstrarea este
            permisă sau impusă de lege.
          </p>
        </section>

        <section className="mb-4">
          <h4 className="fw-semibold">Protecția datelor</h4>
          <p>
            Aplicăm măsuri tehnice și organizatorice pentru protejarea datelor.
            Colaborăm doar cu furnizori care respectă standarde de securitate adecvate.
          </p>
          <p>
            Datele pot fi transferate către parteneri în baza unor acorduri,
            inclusiv în afara UE.
          </p>
          <p className="mb-0">
            Furnizori principali: Firebase, Cloudflare, GitHub.
          </p>
        </section>

        <section className="mb-4">
          <h4 className="fw-semibold">Drepturile dumneavoastră</h4>
          <ul
            className="ps-4"
            style={{
              listStyleType: "disc",
              listStylePosition: "outside",
              marginLeft: 0,
            }}
          >
            <li style={{ display: "list-item", marginBottom: "0.5rem" }}>
              Dreptul de a fi informat
            </li>
            <li style={{ display: "list-item", marginBottom: "0.5rem" }}>
              Dreptul de acces și rectificare
            </li>
            <li style={{ display: "list-item", marginBottom: "0.5rem" }}>
              Dreptul la ștergere și restricționare
            </li>
            <li style={{ display: "list-item", marginBottom: "0.5rem" }}>
              Dreptul la portabilitate
            </li>
            <li style={{ display: "list-item", marginBottom: "0.5rem" }}>
              Dreptul la opoziție
            </li>
            <li style={{ display: "list-item", marginBottom: "0.5rem" }}>
              Dreptul la decizii automate și profilare
            </li>
          </ul>
        </section>

        <section className="mb-4">
          <h4 className="fw-semibold">Informații de contact</h4>
          <p>
            Pentru solicitări privind datele personale, ne puteți contacta la:{" "}
            <a href="mailto:contact@prdp.ro" style={linkStyle}>
              contact@prdp.ro
            </a>
          </p>
          <p>
            Sau către ANSPDCP:{" "}
            <a
              href="https://www.dataprotection.ro"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
            >
              www.dataprotection.ro
            </a>
          </p>
        </section>

        <p className="text-muted small mt-4">
          Această notă este versiunea 1/2025 și poate suferi modificări. Versiunea
          actualizată este disponibilă pe{" "}
          <a
            href="https://prdp.ro/gdpr"
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle}
          >
            proiecte.prdp.ro/gdpr
          </a>
          .
        </p>
      </div>
    </Container>
  );
};

export default GDPRPolicy;
